import styled from "styled-components";

const Board = styled.div<{ isShadow?: boolean }>`
  border-radius: 2rem;
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ isShadow = false }) =>
    isShadow ? "0px 10px 30px 0px rgba(0, 0, 0, 0.1)" : "none"};
`;

export default Board;
